import React, { useEffect, useCallback, useState } from 'react';

import UserService from 'services/user.service';
import AuthServices from 'core/authentication/authService';
import { isMobileDevice } from 'utils/ScreenUtils';

import { useDispatch, useSelector } from 'react-redux';

import Loading from 'components/Loading';
import Animated from 'components/Animated';
import KeycloakPubServiceInstance from 'services/keycloakpubsub.service';
import { useNavigate, useLocation } from 'react-router-dom';
import SliderMessage from 'components/SliderMessage';
import { sendUserDataToAnalytics } from 'utils/gtm';

const LoadUserInfo: React.FC = () => {
  const _userServices = new UserService();
  const _authServices = new AuthServices();

  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showCurrentUserError, setShowCurrentUserError] = useState(false);
  const [textCurrentUserError, setTextCurrentUserError] = useState('');

  const targetPath = isMobileDevice() ? '/pedidos' : '/dashboard';

  function showIntervalMessage(time: number, msg: string) {
    if (msg) setTextCurrentUserError(msg);

    if (time) {
      const idTimeout = setTimeout(() => {
        setShowCurrentUserError(false);
        clearTimeout(idTimeout);
        _authServices.logout();
      }, time);
    }
  }

  const getUserInfo = useCallback(async () => {
    if (!Object.entries(user).length) {
      KeycloakPubServiceInstance.subscribe(async () => {
        await _userServices
          .currentUser()
          .then((result) => {
            if (!result?.data?.enabled) {
              setShowCurrentUserError(true);
              const message = 'Usuário desabilitado, favor entrar em contato com o administrador.';
              showIntervalMessage(5000, message);

              return;
            }

            if (result?.data?.customersRoles?.length === 0) {
              setShowCurrentUserError(true);
              const message = 'Usuário sem vínculo com cliente, favor entrar em contato com o administrador.';
              showIntervalMessage(5000, message);

              return;
            }

            if (result?.data?.pending) {
              throw new Error("Usuário com cadastro incompleto.");
            }

            dispatch({ type: 'SET_USER_DATA', data: result.data });
            return result;
          })
          .then((result) => {
            if (location.pathname === '/') {
              sendUserDataToAnalytics("login", result?.data);
              navigate(targetPath);
            }
          })
          .catch((err) => {
            setShowCurrentUserError(true);

            const userNotRegisterCustomerMessage =
              'Usuário não foi encontrado no portal. Favor entrar em contato com a administração para recadastro';
            const genericMessage =
              'Houve um erro e não foi possível logar no sistema';
            let errorMessage = ', redirecionando para tela de login...';

            if (err?.response?.status === 401)
              errorMessage = userNotRegisterCustomerMessage + errorMessage;
            else if (
              err?.response?.data?.data ===
              'Empresa não encontrada. Favor entrar em contato com a administração para recadastro'
            )
              errorMessage = err?.response?.data?.data + errorMessage;
            else if (err.message === 'Usuário com cadastro incompleto.') {
              errorMessage = err.message;
            }
            else errorMessage = genericMessage + errorMessage;

            showIntervalMessage(5000, errorMessage);
          });
      });
    }
    // eslint-disable-next-line
  }, [dispatch, user, _userServices]);

  useEffect(() => {
    if (!showCurrentUserError) getUserInfo();
  }, []);

  function showAnimated() {
    return (
      !Object.entries(user).length ||
      (user?.userType === 'customer' && !user?.selectedCustomerId)
    );
  }

  return (
    <>
      <SliderMessage
        show={showCurrentUserError}
        message={textCurrentUserError}
      />
      <Animated
        show={showAnimated()}
        animationIn="none"
        animationInDelay="faster"
        animationOut="fadeOut"
        animationOutDelay="delay-1s"
        className="fixed top-0 right-0 bottom-0 left-0 bg-white d-flex align-center justify-center z-999"
      >
        <Loading size={45} />
      </Animated>
    </>
  );
};

export default LoadUserInfo;
